import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Heading } from './NavMenu';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { IrisColors } from "./../css/IRISColors";
import { createContext, useContext, useState } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';

import { UserState } from '../interface/MyInterfaces'
import { SubmissionState } from '../interface/SubmissionInterface'

import { clearSubmissionState, loadSubmissionHistory } from '../actions/SubmissionActions';
import { downloadFactSheet } from '../actions/UserActions';

import Cookies from 'universal-cookie';
import { Heading2 } from './Common/SharedStyledComponents';

import { handleReportDisplayIdChange } from '../actions/UserActions';

interface DashboardProps {
    UserState?: UserState;
    SubmissionState?: SubmissionState;

    loadSubmissionHistory(display_id);
    clearSubmissionState?();

    downloadFactSheet?();
    handleReportDisplayIdChange?(displayId, report_university_name_initial);
    onReleaseDates: (dates: any) => void;

}

interface DashboardState {
    showAll?: boolean;
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false
        }
        this.showMore = this.showMore.bind(this);
    }

    componentDidMount() {
        this.props.loadSubmissionHistory(this.props.UserState.display_id);
        const cookies = new Cookies();
        cookies.set('displayId', this.props.UserState.display_id, { path: '/' });
        cookies.set('schoolName', this.props.UserState.university, { path: '/' });
        cookies.set('schoolLongitude', this.props.UserState.longitude, { path: '/' });
        cookies.set('schoolLatitude', this.props.UserState.latitude, { path: '/' });
    }

    componentDidUpdate(prevProps, prevState) {
        //if (this.props.UserState.qa_account != "Y" && this.props.UserState.report_display_id != this.props.UserState.display_id) {
        //    const { display_id, report_university_name_initial } = this.props.UserState;
        //    this.props.handleReportDisplayIdChange(display_id, report_university_name_initial);
        //}
    }
    
    showMore() {
        this.setState({ showAll: true })
    }

    getFileType_Date(fileType) {
        var last_submitted = "Not Submitted";
        var isSubmitted = false;

        var submissionHistory = this.props.SubmissionState.SubmissionFileHistory;
        if (submissionHistory !== undefined) {
            var history = submissionHistory.filter(x => x.fileType == fileType);
            if (history !== undefined && history[0] !== undefined) {
                var date = new Date(history[0].submissionDate);
                last_submitted = date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
                //current submission date range
                var today = new Date();
                var aprilNextYear = new Date(today.getFullYear() + 1, 3, 15);
                var aprilThisYear = new Date(today.getFullYear(), 3, 15);

                var octoberLastYear = new Date(today.getFullYear() - 1, 9, 15);
                var endOctoberLastYear = new Date(today.getFullYear() - 1, 9, 30);
                var octoberThisYear = new Date(today.getFullYear(), 10, 15);
                var yyyy = today.getFullYear(); // current year


                //between Oct - April
                if (today < aprilThisYear && today > octoberLastYear) {
                    if (date < aprilThisYear && date > endOctoberLastYear) {
                        isSubmitted = true
                    }
                }
                else {
                    if (today > octoberThisYear && today < aprilNextYear) {
                        if (date > octoberThisYear && date < aprilNextYear)
                            isSubmitted = true;
                    }
                    else if (today < octoberThisYear && today > aprilThisYear) {
                        if (date < octoberThisYear && date > aprilThisYear)
                            isSubmitted = true;
                    }
                    else {
                        if (date > aprilThisYear && date < octoberThisYear)
                            isSubmitted = true;
                    }
                }


            }
        }

        if (!isSubmitted) return "Not Submitted";
        return last_submitted;
    }

    public render() {
        let showSpendingReport =
            this.props.UserState.UniversityListSpendingReport && this.props.UserState.UniversityListSpendingReport.find(x => x.display_id == this.props.UserState.display_id) != undefined
        let showImpactFinder = this.props.UserState.UniversityListImpactFinder?.find(x => x.display_id == this.props.UserState.display_id) != undefined

        const userNameLowerCase = this.props.UserState.username.toLowerCase();

        const { hide_impactfinder, hide_spending, hide_sb_employee, hide_employee, hide_vendor, hide_state, hide_congress, hide_one_district, hide_early_career, hide_congress_SB, hide_state_SB } = this.props.UserState;
        if (hide_impactfinder && !userNameLowerCase.startsWith("iris_admin"))
            showImpactFinder = false;

        let showStateReport = this.props.UserState.UniversityListStateReport && this.props.UserState.UniversityListStateReport.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_state_SB && !userNameLowerCase.startsWith("iris_admin"))
            showStateReport = false;

        let showCongressReport = this.props.UserState.FactSheetList && this.props.UserState.FactSheetList.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_congress_SB && !userNameLowerCase.startsWith("iris_admin"))
            showCongressReport = false;
        


        const display_id = this.props.UserState.display_id;
        //const showStateReport = (display_id == "999040" || display_id == "76214" || display_id == "69211" || display_id == "54791" || display_id == "32964" || display_id == "81509");
        let showVendorReport = this.props.UserState.UniversityListVendorReport2025 && this.props.UserState.UniversityListVendorReport2025.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_vendor && !userNameLowerCase.startsWith("iris_admin"))
            showVendorReport = false;

        //let showVendorReport = (this.props.UserState["qa_account"] === "Y" || this.props.UserState.username.toLowerCase().startsWith("iris_admin"));

        let showDetailedDistrictReport = this.props.UserState.UniversityListDetailedDistrictReport && this.props.UserState.UniversityListDetailedDistrictReport.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_one_district && !userNameLowerCase.startsWith("iris_admin"))
            showDetailedDistrictReport = false;

        let showSBEmployeeReport = this.props.UserState.UniversityListSBEmployeeReport && this.props.UserState.UniversityListSBEmployeeReport.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_sb_employee && !userNameLowerCase.startsWith("iris_admin"))
            showSBEmployeeReport = false;

        let showFactSheetReport = this.props.UserState.FactSheetList && this.props.UserState.FactSheetList.find(x => x.display_id == this.props.UserState.display_id) != undefined
        //let showEarlyCareerReport = (this.props.UserState.username == "testadmin@umich.edu");
        let showEarlyCareerReport = (this.props.UserState.UniversityListECR && this.props.UserState.UniversityListECR.find(x => x.display_id == this.props.UserState.display_id) != undefined) || this.props.UserState["qa_account"] === "Y"
        console.log(showEarlyCareerReport);
        if (hide_early_career && !userNameLowerCase.startsWith("iris_admin"))
            showEarlyCareerReport = false;

        var award_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("AWARD") : "-";
        var vendor_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("VENDOR") : "-";
        var subaward_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("SUBAWARD") : "-";
        var employee_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("EMPLOYEE") : "-";
        var empname_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("EMPNAME") : "-";
        var objcode_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("OBJCODE") : "-";
        var suborg_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("SUBORG") : "-";
        var awardidentity_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("AWARDIDENTITY") : "-";
        var coinvestigator_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("COINVESTIGATOR") : "-";
        let dateRange = "Date Range: " + this.props.UserState.submissionDateRange;

        const reports = require('../images/reports.png');
        const submission = require('../images/submission.png');
        const pending = require('../images/pending.png');
        const submitted = require('../images/submitted.png');

        const label_new = require('../images/label_new.png');

        var award_file_type = "award";
        var vendor_file_type = "vendor";
        var subaward_file_type = "subaward";
        var employee_file_type = "employee";
        var empname_file_type = "empname";
        var objcode_file_type = "objcode";
        var suborg_file_type = "suborg";
        var awardidentity_file_type = "awardidentity";
        var coinvestigator_file_type = "coinvestigator";
        
        if (!this.props.UserState.UniversityListSpendingReport || 
            !this.props.UserState.FactSheetList || 
            !this.props.UserState.UniversityListDetailedDistrictReport || 
            !this.props.UserState.UniversityListStateReport) {
            return <div>Loading...</div>;
        }
        
        console.log(this.props.UserState)
        const spendingReleaseDate = this.props.UserState.UniversityListSpendingReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const ecrReleaseDate = this.props.UserState.UniversityListECR.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const sbeReleaseDate = this.props.UserState.UniversityListSBEmployeeReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const vReleaseDate = this.props.UserState.UniversityListVendorReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const vReleaseDate2025 = this.props.UserState.UniversityListVendorReport2025.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const ddReleaseDate = this.props.UserState.UniversityListDetailedDistrictReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const slReleaseDate = this.props.UserState.UniversityListStateReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const fsReleaseDate = this.props.UserState.FactSheetList.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        
        return <div className='container-fluid'>
            <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <ListHeading backgroundColor={IrisColors.secondaryBlue} >
                        <Heading2 color={IrisColors.white}>REPORTS</Heading2>
                        <img height='25px' src={String(reports)} alt='reports icon' />
                    </ListHeading>
                    {
                        showEarlyCareerReport &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports/early-career-report">Early Career Report
                                <i className="fa fa-wrench"></i>
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>{ecrReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showImpactFinder &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/impact-finder">Impact Finder
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>September 2026</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showVendorReport &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports/new-vendor-report2025">Vendor Profile Report
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>{vReleaseDate2025}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showSpendingReport &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports/spending_report">Spending Report
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>{spendingReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showStateReport &&
                        <ListItem>
                            <ListSubItemLeftLink to="/reports/factsheet/stateLegislative">State Legislative Fact Sheet</ListSubItemLeftLink>
                            <ListSubItemRight>{slReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showDetailedDistrictReport &&
                        <ListItem>
                            <ListSubItemLeftLink to="/reports/congressional-district-detail-report">Congressional District Detail Report</ListSubItemLeftLink>
                            <ListSubItemRight>{ddReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        showCongressReport &&
                        <ListItem>
                            <ListSubItemLeftLink to="/reports/factsheet">Congressional District Fact Sheet</ListSubItemLeftLink>
                            <ListSubItemRight>{fsReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }                    
                    {
                        showSBEmployeeReport &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports/employee-report">Employee Profile Report
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>{sbeReleaseDate}</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        this.props.UserState["qa_account"] === "Y" &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports-dashboard/impact-finder">New Impact Finder
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>February 2024</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        this.props.UserState["qa_account"] === "Y" &&
                        <ListItem>
                            <ListSubItemLeftLink target="_blank" to="/reports/CTSA-report">CTSA Report
                                <span className="sr-only">(opens in a new window)</span>
                            </ListSubItemLeftLink>
                            <ListSubItemRight>February 2024</ListSubItemRight>
                        </ListItem>
                    }
                    {
                        this.props.UserState["qa_account"] === "Y" &&
                        <ListItem>
                            <ListSubItemLeftLink to="/reports/agg-CTSA-report">Aggregate CTSA Report</ListSubItemLeftLink>
                            <ListSubItemRight>April 2019</ListSubItemRight>
                        </ListItem>
                    }
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <ListHeading backgroundColor={IrisColors.green} >
                        <Heading2 color={IrisColors.white}>FILE SUBMISSIONS</Heading2>
                        <img height='25px' src={String(submission)} alt='file submissions icon' />
                    </ListHeading>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((award_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Award: </span>{award_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${award_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((vendor_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Vendor: </span>{vendor_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${vendor_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((subaward_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Subaward: </span>{subaward_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${subaward_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((employee_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Employee: </span>{employee_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${employee_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((empname_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Employee Name: </span>{empname_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${empname_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((objcode_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Object Codes: </span>{objcode_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${objcode_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((suborg_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Organizational Units: </span>{suborg_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${suborg_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((awardidentity_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Award Identity: </span>{awardidentity_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${awardidentity_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                    <ListItem>
                        <ListSubItemLeft>
                            <img height='30px' className="mr-3" src={String((coinvestigator_last_submitted == "Not Submitted" ? pending : submitted))} alt='pending' />
                            <span className="font-weight-bold mr-3">Co-investigator: </span>{coinvestigator_last_submitted}
                        </ListSubItemLeft>
                        <ListSubItemRightLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${coinvestigator_file_type}`}>Upload</ListSubItemRightLink>
                    </ListItem>
                </div>
            </div>
        </div>;
    }
}

const ListHeading = styled.div`
display: flex;
justify-content: space-between;
padding-inline: 15px;
padding-block: 7.5px;
background-color: ${props => props.backgroundColor || IrisColors.irisLogoBlue};
`;

const ListItem = styled.div`
display: flex;
justify-content: space-between;
padding-inline: 15px;
padding-block: 10px;
min-height: 20px;
border-left: 1px solid ${IrisColors.grey};
border-right: 1px solid ${IrisColors.grey};
border-bottom: 1px solid ${IrisColors.grey};
`;

const ListSubItemLeftLink = styled(Link)`
font-size: 17px;
color: ${IrisColors.irisLogoBlue}
`;

const ListSubItemLeft = styled.p`
font-size: 17px;
color: ${IrisColors.irisBlack}
`;

const ListSubItemRightLink = styled(Link)`
font-size: 17px;
color: ${IrisColors.secondaryBlue}
text-align: right;
`;

const ListSubItemRight = styled.p`
font-size: 17px;
color: ${IrisColors.irisBlack}
text-align: right;
`;

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    SubmissionState: state.submissionProperties
});

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            clearSubmissionState: clearSubmissionState,
            loadSubmissionHistory: loadSubmissionHistory,
            downloadFactSheet: downloadFactSheet,
            handleReportDisplayIdChange: handleReportDisplayIdChange,
        }, dispatch
    )
}

export default connect(
    mapStateToProps, 
    matchDispatchToProps
)(Dashboard);
